export default __webpack_public_path__ + "static/media/enviro-tree.5443396d.png";